module.exports = __webpack_public_path__ + "static/img/7.1261b27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dglfr/7.png
// module id = DSom
// module chunks = 0